import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <section className="py-14 md:py-24 bg-charcoal-dark border-y border-charcoal-light relative overflow-hidden" data-id="element-275">
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber/5 rounded-full blur-3xl pointer-events-none" data-id="element-276"></div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-277">
        <FadeIn data-id="element-278">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-charcoal border border-amber/30 mb-8" data-id="element-279">
            <ShieldCheckIcon className="w-8 h-8 text-amber" data-id="element-280" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8" data-id="element-281">
            Garantía de Coherencia
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="space-y-6 text-lg text-offwhite-dim" data-id="element-282">
          <p data-id="element-283">RESET no te pide perfección. Te pide que seas completo.</p>
          <p className="text-xl font-medium text-sand" data-id="element-284">
            Si fallás un día, volvés. Sin explicaciones. Sin castigo.
          </p>
          <p className="italic" data-id="element-285">
            La regla madre es simple: no perfecto, completo.
          </p>
          <div className="mt-8 pt-8 border-t border-charcoal-light" data-id="element-286">
            <p data-id="element-287">Y si al día 7 sentís que no movió nada…</p>
            <p className="text-offwhite font-bold mt-2" data-id="element-288">
              me lo decís por WhatsApp y lo vemos juntos.
            </p>
            <p className="mt-4 text-amber font-medium uppercase tracking-widest text-sm" data-id="element-289">
              Sin vueltas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}